import { BorderOutlined } from '@ant-design/icons'
import {
  observationTypeStyles,
  severityStyles,
} from 'pages/pointClouds/components/dropdowns/EnumStyles'
import { TicketStatusTag } from 'pages/pointClouds/components/shared/ObservationTags'
import React from 'react'
import styled from 'styled-components'
import {
  GeckoSiteObservation,
  ObservationType,
  Severity,
  TicketStatus,
} from 'types'

const HeaderWrapper = styled.div`
  > div {
    padding: 4px 0 8px 0 !important;
    margin: 0 !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;

    > div:first-child {
      margin-left: 0 !important;
      padding-left: 0 !important;
    }

    > div:last-child {
      margin-right: 0 !important;
      padding-right: 0 !important;
    }
  }
`

const Header = styled.div`
  height: 40px;
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
`

const HeaderLeft = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  min-width: 48px;
`

const HeaderRight = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

const IconWrapper = styled.div<{ color?: string }>`
  color: ${(props) => props.color || 'inherit'};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`
interface TooltipHeaderProps {
  observation: GeckoSiteObservation
}

export const TooltipHeader: React.FC<TooltipHeaderProps> = ({
  observation,
}) => {
  const severity = observation.data?.severity as Severity | undefined
  const observationType = observation.data?.type as ObservationType | undefined
  const status = observation.data?.status as TicketStatus | undefined

  return (
    <HeaderWrapper>
      <Header>
        <HeaderLeft>
          {severity && severityStyles[severity] && (
            <IconWrapper color={severityStyles[severity].color}>
              {severityStyles[severity].icon}
            </IconWrapper>
          )}
          {observationType && (
            <IconWrapper>
              {observationTypeStyles[observationType]?.icon ?? (
                <BorderOutlined />
              )}
            </IconWrapper>
          )}
        </HeaderLeft>
        <HeaderRight>
          <TicketStatusTag status={status} />
        </HeaderRight>
      </Header>
    </HeaderWrapper>
  )
}
